export function DataTableSkeletonRows({ columnCount, rowCount = 8 }: { columnCount: number; rowCount?: number }) {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, r) => (
        <tr key={r} className="border-b border-border last:border-b-0">
          {Array.from({ length: columnCount }).map((_, c) => (
            <td key={c} className="h-8 px-2.5">
              <span className="block h-3 w-[70%] animate-pulse rounded-sm bg-muted" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
